const dragOverlay = "_35sd14uqbu9";

export { dragOverlay };
import "./atom.drag-overlay.style.linaria.module.css";
//# sourceMappingURL=atom.drag-overlay.style.js.map
